import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DOCUSIGN_TRIGGER_IDS } from '../actionConfigs/shared-action-configurations';

export type SalesforceCallAction = {
  id: string;
  type: string;
  properties: {
    namespace: string;
    fields: {
      action: string;
      comments: string;
    };
  };
};

@Component({
    selector: 'app-salesforce-create-call',
    templateUrl: './salesforce-create-call.component.html',
    styleUrls: ['./salesforce-create-call.component.scss'],
    standalone: false
})
export class SalesforceCreateCallComponent {
  static NAME = 'create-call';
  private static readonly DOCUSIGN_DEFAULT_COMMENTS =
    '<a href="[(${signature.sentResponse.properties.viewLink})]" target="_blank">Open in Docusign</a>';

  @Input() formGroup: FormGroup;
  @Input() triggerId = '';
  @Output() delete: EventEmitter<void> = new EventEmitter();

  get isDocusignAction(): boolean {
    return DOCUSIGN_TRIGGER_IDS.includes(this.triggerId as typeof DOCUSIGN_TRIGGER_IDS[number]);
  }

  static createFormGroup(action?: SalesforceCallAction, triggerId?: string) {
    action = SalesforceCreateCallComponent.create(action, triggerId);
    return new FormGroup({
      id: new FormControl(action.id, Validators.required),
      type: new FormControl(action.type, Validators.required),
      properties: new FormGroup({
        namespace: new FormControl(action.properties?.namespace, Validators.required),
        fields: new FormGroup({
          action: new FormControl(action.properties?.fields?.action, Validators.required),
          comments: new FormControl(action.properties?.fields?.comments),
        }),
      }),
    });
  }

  static isAction(action: any): boolean {
    return action.id.endsWith(this.NAME);
  }

  static create(existing?: SalesforceCallAction, triggerId?: string): SalesforceCallAction {
    const isDocusign = DOCUSIGN_TRIGGER_IDS.includes(triggerId as typeof DOCUSIGN_TRIGGER_IDS[number]);
    const defaultComments = isDocusign ? SalesforceCreateCallComponent.DOCUSIGN_DEFAULT_COMMENTS : undefined;
    return {
      id: existing?.id ?? `salesforce.${SalesforceCreateCallComponent.NAME}`,
      type: existing?.type ?? 'task',
      properties: {
        namespace: existing?.properties?.namespace ?? 'salesforce',
        fields: {
          action: existing?.properties?.fields?.action,
          comments: existing?.properties?.fields?.comments ?? defaultComments,
        },
      },
    };
  }

  removeAction() {
    this.delete.emit();
  }
}
